module.exports = __webpack_public_path__ + "youtrack.16c1a1.svg";